import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";
import { Button } from "../components/ui/button";

const STATUS_COLORS = {
  placed: "bg-[#FFF5F3] text-[#8B1E28]",
  paid: "bg-[#FFF5F3] text-[#8B1E28]",
  shipped: "bg-blue-50 text-blue-700",
  delivered: "bg-green-50 text-green-700",
  cancelled: "bg-red-50 text-red-700",
};

export default function Orders() {
  const { user, login, loading } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) { login(); return; }
    if (user) axios.get(`${API}/orders`).then(r => setOrders(r.data));
  }, [user, loading, login]);

  if (!user) return <div className="max-w-7xl mx-auto px-4 py-20 text-center text-[#8A8480]">Please sign in.</div>;

  const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="orders-page">
      <h1 className="font-display text-4xl text-[#2C2A29] mb-2">My orders</h1>
      <p className="text-sm text-[#8A8480] mb-10">{orders.length} {orders.length === 1 ? "order" : "orders"} placed</p>

      {orders.length === 0 ? (
        <div className="text-center py-20 bg-white border border-[#EAE3D9] rounded-2xl" data-testid="orders-empty">
          <p className="font-display text-2xl text-[#2C2A29]">No orders yet</p>
          <Link to="/products"><Button className="btn-primary mt-6 rounded-full px-6 py-5 h-auto">Start shopping</Button></Link>
        </div>
      ) : (
        <div className="space-y-4" data-testid="orders-list">
          {orders.map(o => (
            <div key={o.order_id} className="bg-white border border-[#EAE3D9] rounded-2xl p-5" data-testid={`order-${o.order_id}`}>
              <div className="flex items-center justify-between flex-wrap gap-3 mb-3">
                <div>
                  <div className="text-xs text-[#8A8480]">Order</div>
                  <div className="font-semibold text-[#2C2A29]">{o.order_id}</div>
                </div>
                <span className={`label-small px-3 py-1 rounded-full ${STATUS_COLORS[o.status] || ""}`}>{o.status}</span>
                <div className="text-right">
                  <div className="text-xs text-[#8A8480]">Total</div>
                  <div className="font-semibold text-[#8B1E28]">{inr(o.total)}</div>
                </div>
              </div>
              <div className="flex gap-3 overflow-x-auto pb-2">
                {o.items.map((it, i) => (
                  <div key={i} className="shrink-0 flex items-center gap-3 bg-[#FFF5F3]/60 rounded-xl p-2 pr-4 border border-[#EAE3D9]">
                    <img src={it.image} alt="" className="h-12 w-12 rounded-lg object-cover bg-white" />
                    <div>
                      <div className="text-sm line-clamp-1 max-w-[170px]">{it.name}</div>
                      <div className="text-xs text-[#8A8480]">Qty {it.quantity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
